export const getLandingPageFooterStyles = () => ({
  footerContainer: {
    width: '100%',
    height: '50px',
    backgroundColor: '#1B1B1B',
    paddingTop: '10px',
    paddingLeft: '30px',
  },
  'footerContainer-m': {
    height: 80,
  },
  'footerContainer-s': {
    height: 80,
    paddingLeft: 5,
  },
  footerContainerInner: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    paddingLeft: 0,
    '& li': {
      display: 'inline-block',
      color: '#FFFFFF',
    },
  },
  footerManageCookies: {
    '& button': {
      border: 'none',
      background: 'transparent',
      padding: '0 5px',
      verticalAlign: 'baseline',
      textDecorationThickness: '1px',
      fontWeight: 400,
    },
    '& button:hover': {
      background: 'transparent',
    },
    '& button:focus:active': {
      background: 'transparent',
    },
  },
  linkContainer: {
    paddingLeft: '5px !important',
    paddingRight: '5px !important',
    marginRight: '20px !important',
    display: 'block',
    lineHeight: '20px',
    color: '#FFFFFF !important',
    textDecorationLine: 'underline !important',
    fontSize: '12px !important',
  },
  'linkContainer-s': {
    paddingLeft: '0px !important',
    paddingRight: '0px !important',
    marginRight: '5px !important',
    fontSize: '12px !important',
  },
});
